export default __webpack_public_path__ + "static/media/GHSI Related Party Transaction Policy.a6165656.pdf";